import { render, staticRenderFns } from "./AssignUser.vue?vue&type=template&id=147fe4c7&scoped=true&"
import script from "./AssignUser.vue?vue&type=script&lang=js&"
export * from "./AssignUser.vue?vue&type=script&lang=js&"
import style0 from "./AssignUser.vue?vue&type=style&index=0&id=147fe4c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147fe4c7",
  null
  
)

export default component.exports